import React, { Component } from 'react';
import { Nav as NavBS } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Logout from '../Login/Logout';

class NavLoggedIn extends Component {
    logout() {
        this.props.auth.logout();
    }

    render() {
        return (
            <div>
                <NavBS>
                    <Link to="/chat" className="navigation__menuItem"><div>Chat</div></Link>
                    <Link to="/addRide" className="navigation__menuItem"><div>Ajouter Balade</div></Link>
                    <Link to="/rider" className="navigation__menuItem"><div>Profile</div></Link>
                    <Link to="/aide" className="navigation__menuItem"><div>Aide</div></Link>
                    <Link to="/" onClick={this.logout.bind(this)} className="navigation__menuItem"><Logout /></Link>
                </NavBS>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.lang
});
export default connect(mapStateToProps)(NavLoggedIn);